import { createAction, props } from '@ngrx/store';
import { Seasons, SportsAssociation } from './seasons.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records seasons'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records seasons success', 
    props<{ listData: Seasons[], total: number, sportsAssociation: SportsAssociation[] }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records seasons failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record seasons',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record seasons success', 
    props<{ singleData: Seasons, sportsAssociation: SportsAssociation[] }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record seasons failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record seasons',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record seasons success'
);
export const addRecordFailure = createAction(
    '[Data] Add record seasons failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record seasons',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record seasons success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record seasons failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record seasons',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record seasons success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record seasons failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state seasons',
);